import { createContext } from "react";

export default createContext<any>({ offset: 0 });
